import { useEffect, useState } from "react";
import { Trophy, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AMBASSADOR_UNLOCKED_EVENT } from "@/components/shared/ReferralWinWatcher";

// Small persistent on-site perk callout — shown once a referrer's own link has
// brought in 5+ sign-ups (flag set by ReferralWinWatcher). Dismissible per visit.
export const AmbassadorBadge = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("rr_ambassador_unlocked")) setVisible(true);

    const handler = () => setVisible(true);
    window.addEventListener(AMBASSADOR_UNLOCKED_EVENT, handler);
    return () => window.removeEventListener(AMBASSADOR_UNLOCKED_EVENT, handler);
  }, []);

  if (!visible || dismissed) return null;

  return (
    <div
      data-testid="ambassador-badge"
      className="fixed bottom-4 right-4 z-[999] flex items-center gap-2.5 bg-rr-navy text-white rounded-full pl-4 pr-3 py-2.5 shadow-2xl shadow-black/30 border border-white/10"
    >
      <button
        onClick={() => navigate("/ambassador-program")}
        data-testid="ambassador-badge-link"
        className="flex items-center gap-2.5 hover:opacity-80 transition-opacity"
      >
        <Trophy size={16} className="text-rr-orangeLight shrink-0" />
        <span className="text-xs font-bold whitespace-nowrap">🏆 Top 10 Founding Ambassador</span>
      </button>
      <button
        onClick={() => setDismissed(true)}
        data-testid="ambassador-badge-dismiss"
        aria-label="Dismiss"
        className="text-white/50 hover:text-white transition-colors shrink-0"
      >
        <X size={14} />
      </button>
    </div>
  );
};
